
/**
 * 상세 에러 정보 (선택적)
 * @nullable
 */
export type DeleteConversation401Details = { [key: string]: unknown } | null;
